'use strict';

var NAME           = 'spinner';
var NAMESPACE      = 'hogo.' + NAME;
var SELECTOR       = '[data-' + NAME + ']';
var DISABLED_CLASS = 'disabled';

var $body = $(document.body);

/**
 * Constructor.
 *
 * @param  {DOMElement|string}  element
 * @param  {object}             options
 */
var Spinner = function (element, options)
{
	this.$element = $(element);

	// Optional text to display alongside the value.
	var text  = this.$element.data(NAME);
	var range = this.$element.data('range');

	this.value = parseInt(this.$element.val(), 10) || 0;

	// Split the range into min/max and convert to int.
	if (range) {
		range = range.split('-');
		this.min = +range[0];
		this.max = +range[1];
	}


	// Build the DOM
	this.$increase = $('<div class="' + NAME + '-increase">+</div>');
	this.$decrease = $('<div class="' + NAME + '-decrease">-</div>');
	this.$display  = $('<div class="' + NAME + '-display"></div>');
	this.$value    = $('<span class="' + NAME + '-value">0</span>')
						.appendTo(this.$display);

	// Optional text
	if (text) {
		this.$label = $('<span class="' + NAME + '-label">' + text + '</span>')
			.appendTo(this.$display);
	}

	// Wrap the element with the container.
	this.$container = $('<div class="' + NAME + '"></div>');
	this.$element
		.addClass(NAME + '-control')
		.wrap(this.$container)
		.before(this.$decrease, this.$increase, this.$display)
		.hide();

	this.update();
};

Spinner.VERSION = '0.1.0';

/**
 * Updates the display based on the current value of the field.
 */
Spinner.prototype.update = function ()
{

	this.$element.val(this.value);
	this.$value.text(this.value);


	// Range test.
	if (this.value <= this.min) {
		this.$decrease.addClass(DISABLED_CLASS);
	} else {
		this.$decrease.removeClass(DISABLED_CLASS);
	}

	if (this.value >= this.max) {
		this.$increase.addClass(DISABLED_CLASS);
	} else {
		this.$increase.removeClass(DISABLED_CLASS);
	}
}

/**
 * Increase the spinner count by 1 or a specified number.
 *
 * @param  {object}  e
 */
Spinner.prototype.decrease = function (amount)
{

	amount = amount || 1;

	this.value -= amount;

	if (this.value <= this.min) {
		this.value = this.min;
	}

	this.update();
}

/**
 * Decrease the spinner count by 1 or a specified number.
 *
 * @param  {object}  e
 */
Spinner.prototype.increase = function (amount)
{
	amount = amount || 1;

	this.value += amount;

	if (this.value >= this.max) {
		this.value = this.max;
	}

	this.update();
}



// SPINNER PLUGIN DEFINITION
// =========================

function Plugin (option)
{
	var args = [];
	for (var i = 1; i < arguments.length; i++) {
		args.push(arguments[i]);
	}

	return this.each(function () {
		var $this = $(this);
		var data  = $this.data(NAMESPACE);

		if ( ! data) $this.data(NAMESPACE, (data = new Spinner(this)));
		if (typeof option === 'string') data[option].apply(data, args);
	});
}

$.fn.spinner             = Plugin;
$.fn.spinner.Constructor = Spinner;


// APPLY TO STANDARD SPINNER ELEMENTS
// ==================================

$(SELECTOR).spinner();


// BIND EVENTS
// ==================================

$(document)
	.on('click.' + NAMESPACE + '.increase', '.' + NAME + '-increase', function (e) {
		var $spinner = $(e.target).siblings('input');
		Plugin.call($spinner, 'increase', 1);
	})
	.on('click.' + NAMESPACE + '.decrease', '.' + NAME + '-decrease', function (e) {
		var $spinner = $(e.target).siblings('input');
		Plugin.call($spinner, 'decrease', 1);
	});


// EXPORT MODULE
// =============

export default Spinner;